import React, { useState } from 'react';
import Title from '../components/Title/Title';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
import Section from '../components/Modular/Section';
import { Card } from '../components/Card';
import Unit from '../components/Modular/Unit';
import MicroUnit from '../components/Modular/MicroUnit';
import ServiceOffering from '../components/ServiceOffering/ServiceOffering';
import Layout from '../components/Modular/Layout';
import Carousel from '../components/Carousel/Carousel';
import DropDown from '../components/DropDown/DropDown';
import { useWindowSize } from '../hooks/useWindowSize';
import { useLocation } from 'react-router-dom';
import Nav from '../components/Nav/Nav';

const categories = [
  {
    title: 'Dental/Medical',
    subtitle: 'dental sites for building trust and online communication.',
    projects: [{ title: '100Smiles', link: 'https://100smiles.netlify.app/' }],
  },
  {
    title: 'Restaurants',
    subtitle: 'restaurant sites for menu browsing and table booking.',
    projects: [
      {
        title: 'Sunshine Cafe',
        link: 'https://sunrise-cafe-ae8267.netlify.app/',
      },
    ],
  },
  // {
  //   title: 'Portfolios',
  //   subtitle:
  //     'portfolio sites for communicating design and artistic expertise.',
  //   projects: [{ title: 'Aria Portfolio' }, { title: 'Mika Motion Studio' }],
  // },
  // {
  //   title: 'Trade Services',
  //   subtitle:
  //     'Business sites for plumbers, electricians, builders and carpenters.',
  //   projects: [{ title: 'Ace Plumbing' }, { title: 'Green Electric' }],
  // },
  // {
  //   title: 'Law/Real Estate',
  //   subtitle:
  //     'Business sites for communicating legal and real estate expertise.',
  //   projects: [{ title: 'Smith & Co. Law' }, { title: 'Urban Realty' }],
  // },
  // {
  //   title: 'Pet Groomers/Vets',
  //   subtitle: 'Business sites for communicating pet care services.',
  //   projects: [
  //     { title: 'Paws & Claws Grooming' },
  //     { title: 'Happy Tails Vet' },
  //   ],
  // },
  {
    title: 'Education',
    subtitle: 'education sites for course browsing and online enrolment.',
    projects: [
      {
        title: 'Quizone',
        link: 'https://sienna-salmon-636665.hostingersite.com/quiz_app/',
      },
    ],
  },
];

export const ProjectsPage = () => {
  const windowSize = useWindowSize();
  const buttonLayout = windowSize.width <= 798 ? 'grid' : 'flex';
  const responsiveTitle = windowSize.width <= 798 ? 'center' : 'left';
  const responsiveWidth = windowSize.width <= 798 ? '3' : '9';
  const responsiveTracking = windowSize.width <= 798 ? 175 : 100;

  const [navDropDown, setNavDropDown] = useState(false);

  const toggleNavMobile = () => {
    setNavDropDown((prev) => !prev);
  };

  const context = {
    section: {
      layout: 'grid',
      background: 'dark',
      justifyItems: 'center',
      gap: 'md',

      // padding: 'py-6',
    },
    unit: {
      colSpan: '1',
      rowSpan: '1',
      justifyContent: 'center',
    },
  };

  return (
    <Layout
      layout="grid"
      gap="md"
      // positioning="centered"
      alignContent="center"
      justifyContent="center"
      background="dark"
      context={context}
    >
      <Section layout="grid" gap="md">
        <Title responsiveTitle={responsiveTitle}></Title>

        <Section
          justifyItems="left"
          justifyContent="center"
          width={responsiveWidth}
        >
          <Carousel
            items={categories}
            responsiveTracking={responsiveTracking}
          ></Carousel>
        </Section>
        <Section
          layout={buttonLayout}
          gridTemplate={`${buttonLayout === 'grid' ? 'vertical-4' : ''}`}
          gap="sm"
          justifyItems="center"
          justifyContent="center"
          width={responsiveWidth}
        >
          {windowSize.width >= 798 && <Nav></Nav>}

          {windowSize.width <= 798 && (
            <DropDown
              navDropDown={navDropDown}
              toggleNavMobile={toggleNavMobile}
            ></DropDown>
          )}
        </Section>
      </Section>
    </Layout>
  );
};
